export const awsConfig = {
  Auth: {
    region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
    userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
    endpoint: process.env.REACT_APP_COGNITO_ENDPOINT || undefined,
  },
  API: {
    endpoint: process.env.REACT_APP_API_ENDPOINT || 'http://localhost:4566',
  }
};
